export const PREDEFINED_COLORS = [
  '#280000',
  '#7c0900',
  '#ff7754',
  '#ff996c',
  '#ba6d00',
  '#e3ac00',
  '#f1d800',
  '#fff69a',
  '#fffcc9',
  '#7aa400',
  '#2e5a00',
  '#b0ff75',
  '#70ff2b',
  '#28c100',
  '#002208',
  '#01b454',
  '#95ffcd',
  '#007455',
  '#02e3c1',
  '#00554a',
  '#9afff3',
  '#002427',
  '#00cae8',
  '#74ecff',
  '#017ea0',
  '#0083dc',
  '#62baff',
  '#bbdeff',
  '#003263',
  '#01429c',
  '#0027aa',
  '#aab5ff',
  '#b094ff',
  '#702dff',
  '#b162ff',
  '#13001c',
  '#eebeff',
  '#24002e',
  '#9a009a',
  '#ff90fc',
  '#5d004e',
  '#ff51d4',
  '#ff88cf',
  '#bb006c',
  '#5a0031',
  '#f4007c',
  '#8f0033',
  '#600015',
  '#ff9cab',
  '#ff2f3b',
  '#000000',
  '#ffffff',
  '#cccccc',
];
